import React                       from 'react';
import { Observe }                      from 'rewire-core';
import Typography                       from '@material-ui/core/Typography';
import LockIcon                         from '@material-ui/icons/Lock';
import { Theme, StyleType, makeStyles } from '../utility/styles';
import { TemplateDialogModel }          from '../schedule/TemplateDialogModel';
import { useCardStyle }                 from './UdfEditor';
import InfoPanelHeader                  from '../ui/InfoPanelHeader';
import SettingsModel                    from './SettingsModel';

const titleStyles = (_theme: Theme) => ({
  titleLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  lockIcon: {
    marginLeft: '10px',
    marginBottom: '3px',
  },
});

const useTitleStyles = makeStyles(titleStyles);

const TemplateEditPanelHeaderTitle = ({ title, locked }: { title: string, locked: boolean }) => {
  const classes = useTitleStyles();
  return (
    <div className={classes.titleLabel}>
      <Typography variant='h5'>{title}</Typography>
      {locked && <LockIcon className={classes.lockIcon} />}
    </div>
  );
};

const TemplateEditPanelHeaderView = ({ settings }: { settings: SettingsModel, classes: StyleType<typeof useCardStyle> }) => {
  return <Observe render={() => {
    const locked             = (settings.editor as TemplateDialogModel).locked;
    const headerOptionsTitle = `${settings.title} Options`;
    return (
      <InfoPanelHeader
        title={<TemplateEditPanelHeaderTitle title={settings.title} locked={locked} />}
        subTitle={`${(settings.selectedItem && settings.editor?.title) || ''}`}
        optionsMenuTitle={headerOptionsTitle}
        optionsMenuTooltip={headerOptionsTitle}
        optionsItems={settings.getDefaultEditPanelHeaderOptionsItems()}
      />
    );
  }} />;
};

export default TemplateEditPanelHeaderView;